import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(VTextField, {
    ref: "df-text-field",
    staticClass: "df-text-field",
    attrs: {
      hint: _vm.schema.hint,
      label: _vm.schema.label,
      mask: _vm.schema.mask,
      maxlength: _vm.schema.maxLength,
      "persistent-hint": true,
      rules: _vm.rules,
      type: _vm.inputType,
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }